import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const easeOut = [0.23, 1, 0.32, 1] as const;
const heroHighlights = ['6 Complete Volumes', '150 Ready-to-Coach Sessions', '5 Professional Bonus Guides', 'Immediate Access'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-[#081632]" data-id="element-103" data-mp="128phrcgdev41">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-104" data-mp="xaxexne6tol2">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} className="w-full" data-id="element-105" data-mp="sa9n4zi4x3ps">
          <div className="inline-block px-3 py-1 rounded-full border border-[#D89B16]/60 bg-white/5 text-[#D89B16] font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-106" data-mp="3d2ldtocrhr6i">
            🥋 JUDO COACH READY
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6 text-white" data-id="element-107" data-mp="3j6oe7qokeyt9">
            Solve months of Judo session planning in just{' '}
            <span className="text-[#D89B16]" data-id="element-108" data-mp="39cpc2rohrf1b">5 MINUTES</span>
          </h1>

          <p className="text-sm sm:text-base md:text-lg text-white/80 max-w-3xl mx-auto mb-4 sm:mb-6" data-id="element-109" data-mp="3e7uzjuxjl1ri">
            Judo Coach Ready —{' '}
            <span className="text-[#D89B16] font-semibold" data-id="element-110" data-mp="358hleoyh3p0g">150 ready-to-coach</span> Judo sessions, 6
            complete volumes and{' '}
            <span className="text-[#D89B16] font-semibold" data-id="element-111" data-mp="2ql6b0qe12b1x">5 professional bonus guides</span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: easeOut
      }} className="relative w-full max-w-[320px] sm:max-w-lg md:max-w-3xl mb-4 sm:mb-6" data-id="element-112" data-mp="2vj7wfhyxemgk">
          <img src={HERO_IMAGE} alt="Judo Coach Ready complete system: 6 volumes, 150 ready-to-coach sessions and 5 bonus guides" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-113" data-mp="s3mc1z88nsws" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: easeOut
      }} className="w-full" data-id="element-114" data-mp="ddf44dfuxsac">
          <p className="text-sm sm:text-lg md:text-xl text-white/85 leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-115" data-mp="161auz1iqwpz7">
            150 ready-to-coach Judo sessions designed to help coaches plan less, teach with more
            structure and develop judoka from beginner fundamentals to functional application.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-116" data-mp="3ltqdrg1k11v3">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10" data-id="element-117" data-mp="3hrlkiif0q78z">
              🟡 GET THE COMPLETE JUDO COACHING SYSTEM NOW
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-white/70" data-id="element-118" data-mp="269zk1xtv35qi">
            {heroHighlights.map(highlight => <div key={highlight} className="flex items-center gap-1.5" data-id="element-119" data-mp="2b2aggqpe89eb">
                <CheckCircle size={14} className="text-[#D89B16]" data-id="element-120" data-mp="2fyr5dn4f2rsg" />
                <span data-id="element-121" data-mp="2kyvqjqg9sap0">{highlight}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}